import React, { useState } from 'react';
import { useWindowSize } from 'react-use';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components/macro';
import { Layout } from 'models/documents';
import utils from 'utils';
import selectors from 'state/selectors';
import actions from 'state/actions';
import RadioButton from 'components/Buttons/RadioButton';
import Modal from 'components/Modal';

const OptionGroup = styled.section`
  margin-bottom: 20px;
  margin-left: 10px;
`;

const H4 = styled.h4`
  font-family: ${({ theme }) => theme.fontFamily};
  font-weight: ${({ theme }) => theme.fontWeightPalette.light};
  font-size: ${({ theme }) => theme.fontSizePalette.large};
  color: ${({ theme }) => theme.colorPalette.grey.grey7};
  margin-bottom: 7px;
`;

const LayoutModal = () => {
  const programCode = useSelector(selectors.app.getProgramCode);
  const layout = useSelector(selectors.documents.selectLayout);
  const [tempLayout, setTempLayout] = useState<Layout>(layout);
  const t = utils.intl.useTranslator();
  const dispatch = useDispatch();
  const { width: screenWidth } = useWindowSize();

  const confirmLayout = () => {
    dispatch(actions.documents.setLayout(tempLayout));
    window.localStorage.setItem(`documents-${programCode}-layout`, tempLayout);
    dispatch(actions.modal.closeModal());
  };

  const onConfirm = confirmLayout;

  return (
    <>
      <Modal.Header title={t('layout')} subtitle={t('layout-description')} />
      <Modal.Content>
        <OptionGroup>
          <H4>{t('document-preview')}</H4>
          <RadioButton
            value={tempLayout}
            options={[
              { value: 'rows', label: t('horizontalView') },
              {
                value: 'columns',
                label: `${t('verticalView')} ${screenWidth <= 1240 ? `(${t('disabled_under_1240')})` : ''}`,
                disabled: screenWidth <= 1240,
              },
              { value: 'full', label: t('noPreview') },
            ]}
            onChange={(value) => {
              setTempLayout(value as Layout);
            }}
          />
        </OptionGroup>
      </Modal.Content>
      <Modal.Footer confirmText={t('confirm-customization')} confirmAction={onConfirm} />
    </>
  );
};

export default LayoutModal;
